import { useIntersectionObserver } from '@packages/shared/src/hooks/useIntersectionObserver/useIntersectionObserver';
import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import type {
  GTMEventGlycerinButtonClick,
  GTMEventGlycerinDisplayButton,
  GTMEventGlycerinDisplayOverlay,
} from '@packages/tracking/src/types/events';

export type Vendor = 'Loadbee' | 'Flixmedia';

export type UseManufacturerTrackingProps = {
  brandName: string;
  ref: React.RefObject<Element | null>;
  vendor: Vendor;
};

export const useManufacturerTracking = ({
  brandName,
  ref,
  vendor,
}: UseManufacturerTrackingProps) => {
  const dispatchTracking = useTracking();

  useIntersectionObserver(ref, {
    intersectOnce: true,
    threshold: 1,
    callback: (isIntersecting) => {
      if (!isIntersecting) {
        return;
      }
      // intersectOnce is set to true, so this callback will only be called once
      dispatchTracking<GTMEventGlycerinDisplayButton>({
        event: 'DisplayButton',
        DisplayButtonData: {
          category: `Herstellerinformationen ${brandName}`,
          detail: vendor,
          label: 'Content-Products',
        },
      });
    },
  });

  const trackGlycerinButtonClick = () => {
    dispatchTracking<GTMEventGlycerinButtonClick>({
      event: 'ButtonClick',
      ButtonClickData: {
        category: `Herstellerinformationen ${brandName}`,
        detail: vendor,
        label: 'Content-Products',
      },
    });
  };

  const trackGlycerinDisplayOverlay = () => {
    dispatchTracking<GTMEventGlycerinDisplayOverlay>({
      event: 'DisplayOverlay',
      DisplayOverlayData: {
        category: `Herstellerinformationen ${brandName}`,
        detail: vendor,
        label: 'Content-Products',
      },
    });
  };

  return { trackGlycerinButtonClick, trackGlycerinDisplayOverlay };
};
